import React from 'react';
import Navbar from './Navbar';
 
import Search from '../Components/Search'
import BottomNavigation from 'react-bottom-navigation';
import { FaHome, FaSearch, FaUser, FaBars } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
const Header = () => {
  return (
    <header className="main_header_area position-absolute w-100 site-header">
      {/* Top bar with social and contact info */}
      <div className="header-content text-white">
        <div className="container">
          <div className="header-content-inner py-2">
            <div className="row align-items-center">
           
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Bar */}
   <div className="header_menu" id="header_menu">
        <div className="container">
          <nav className="navbar navbar-expand-lg py-2 w-100">
            <div className="row w-100 align-items-center">
              <div className="col-lg-2 col-md-6">
              <div className="navbar-brand m-0">
                  <img src="assets/images/logo/1.png" alt="Logo" className="w-100" />
                </div> 
              </div>
 
              <div className="col-lg-7 col-md-6">
            <Navbar/> 
              </div>    

              <div className="col-lg-3">
                <div className="menu-search text-end">
                  {/* <Search /> */}
                    
                  <Link to="/Profile" className="btn btn3">
                  My Profile
                   {/* <i className="fa fa-long-arrow-right ms-4"></i> */}
                  </Link>
                </div>
              </div>
            </div>
          </nav>
          <div id="slicknav-mobile"></div>
        </div>
      </div>  

   
    </header>
  );
};

export default Header;
